import zxcvbn from 'zxcvbn';

export default function PasswordStrengthIndicator({ password }) {
  if (!password) return null;

  const { score } = zxcvbn(password);
  const strengthLabels = ['A total loser', 'Tremendous failure', 'Its fine, believe me', 'The best, folks', 'Yuge, just yuge'];

  return (
    <div className="relative h-5 w-full bg-gray-200 rounded mt-2">
      <div
        className={[
          'flex items-center justify-center h-full rounded transition-all duration-300 text-xs text-white',
          score === 0
            ? 'bg-red-500 w-1/5'
            : score === 1
              ? 'bg-red-500 w-2/5'
              : score === 2
                ? 'bg-yellow-500 w-3/5'
                : score === 3
                  ? 'bg-green-500 w-4/5'
                  : 'bg-green-600 w-full',
        ].join(' ')}
      >
        {strengthLabels[score]}
      </div>
    </div>
  );
}
